import { render, staticRenderFns } from "./CustomerPortalView.vue?vue&type=template&id=67269dc0&scoped=true"
import script from "./CustomerPortalView.vue?vue&type=script&lang=js"
export * from "./CustomerPortalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67269dc0",
  null
  
)

export default component.exports